import React, { PropsWithChildren, useContext } from 'react';
import { BillToReceiveReleaseDetailContext } from './ReleaseDetailProvider.types';
import { useParams } from 'react-router-dom';

const ReleaseDetailContext = React.createContext(
  {} as BillToReceiveReleaseDetailContext,
);

export function useBillToReceiveReleaseDetailContext() {
  return useContext(ReleaseDetailContext);
}

export default function BillToReceiveReleaseDetailProvider(
  props: PropsWithChildren<unknown>,
) {
  const params = useParams<{
    releaseId: string;
    installmentId: string;
  }>();

  return (
    <ReleaseDetailContext.Provider
      value={{
        releaseId: Number(params.releaseId),
        installmentId: Number(params.installmentId),
      }}
    >
      {props.children}
    </ReleaseDetailContext.Provider>
  );
}
